import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "@/lib/theme";
import { AuthProvider } from "@/lib/auth";
import { BookmarkProvider } from "@/lib/bookmarks";
import { createQueryClient } from "@/lib/api";
import { ToastProvider } from "@/components/ui/Toast";
import { mountTarget } from "@/lib/prerender";
import App from "./App";
import "./fonts";
import "./index.css";

const queryClient = createQueryClient();

ReactDOM.createRoot(mountTarget(document.getElementById("root")!, queryClient)).render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <ThemeProvider>
            <BookmarkProvider>
              <ToastProvider>
                <App />
              </ToastProvider>
            </BookmarkProvider>
          </ThemeProvider>
        </AuthProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
